"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearKevelBannersFromJlData = exports.addKevelBannerToJlData = exports.clearCitrusBannersFromJlData = exports.addCitrusBannerToJlData = void 0;
const addCitrusBannerToJlData = ({ adId, type, campaignName, }) => {
    if (window && adId && campaignName && type) {
        const ad = {
            adId,
            type,
            campaignName,
        };
        window.jlData = Object.assign(Object.assign({}, window.jlData), { citrusBannerAds: [ad] });
    }
};
exports.addCitrusBannerToJlData = addCitrusBannerToJlData;
const clearCitrusBannersFromJlData = () => {
    var _a;
    if ((_a = window === null || window === void 0 ? void 0 : window.jlData) === null || _a === void 0 ? void 0 : _a.citrusBannerAds) {
        delete window.jlData.citrusBannerAds;
    }
};
exports.clearCitrusBannersFromJlData = clearCitrusBannersFromJlData;
const addKevelBannerToJlData = ({ adId, type, clickUrl, impressionUrl, }) => {
    if (window && adId && type && clickUrl && impressionUrl) {
        const ad = {
            adId,
            type,
            clickUrl,
            impressionUrl,
        };
        window.jlData = Object.assign(Object.assign({}, window.jlData), { kevelBannerAds: [ad] });
    }
};
exports.addKevelBannerToJlData = addKevelBannerToJlData;
const clearKevelBannersFromJlData = () => {
    var _a;
    if ((_a = window === null || window === void 0 ? void 0 : window.jlData) === null || _a === void 0 ? void 0 : _a.kevelBannerAds) {
        delete window.jlData.kevelBannerAds;
    }
};
exports.clearKevelBannersFromJlData = clearKevelBannersFromJlData;
